function UnitSection({ unitNumber, children, className = "" }) {
  return (
    <section className={`dashboard-unit-section ${className}`.trim()}>
      <header className="dashboard-unit-header">
        <h3 className="dashboard-unit-title">Unit {unitNumber}</h3>
      </header>
      <div className="dashboard-unit-tiles">
        {children}
      </div>
    </section>
  );
}

export default UnitSection;
